export const getResolvedFileSize = (size: number) => {
  const sizes = ['bytes', 'KB', 'MB', 'GB', 'TB'];
  if (size === 0) return '0 bytes';
  if (size === 1) return '1 byte';

  let i = Math.floor(Math.log(size) / Math.log(1000));
  let num = size / Math.pow(1000, i);
  return `${Math.ceil(num * 10) / 10} ${sizes[i]}`;
};

export const isGreaterThanDownloadLimit = (size: number) => {
  return size > 10000000
}
